import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const listResource = async (path) => (await api.get(`/${path}`)).data;
export const createResource = async (path, body) => (await api.post(`/${path}`, body)).data;
export const updateResource = async (path, id, body) => (await api.put(`/${path}/${id}`, body)).data;
export const deleteResource = async (path, id) => (await api.delete(`/${path}/${id}`)).data;
export const getSummary = async () => (await api.get(`/summary`)).data;
export const getReminders = async () => (await api.get(`/reminders`)).data;
export const shiftTruckingDates = async (days) => (await api.post(`/trucking/shift-dates`, { days })).data;
export const markWorkorderDone = async (id) => (await api.post(`/workorders/${id}/mark-done`)).data;
export const geocodeAddress = async (q) => (await api.get(`/geocode`, { params: { q } })).data;
export const getTruckingAlert = async () => (await api.get(`/trucking-alert`)).data;
export const setTruckingAlert = async (body) => (await api.put(`/trucking-alert`, body)).data;

// Attachments (photos & documents)
export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;
export const downloadUrl = (storagePath, filename) =>
  `${API}/files/${storagePath}?download=1&filename=${encodeURIComponent(filename || "")}`;
export const uploadAttachment = async (path, id, file, kind, initials) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  fd.append("initials", initials);
  return (await api.post(`/${path}/${id}/attachments`, fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const deleteAttachment = async (path, id, attId) => (await api.delete(`/${path}/${id}/attachments/${attId}`)).data;

// Auth
export const postSession = async (sessionId) =>
  (await api.post(`/auth/session`, {}, { headers: { "X-Session-ID": sessionId } })).data;
export const getMe = async () => (await api.get(`/auth/me`)).data;
export const logoutApi = async () => (await api.post(`/auth/logout`)).data;
